module.exports = __webpack_public_path__ + "static/media/initiated.c1dbf39c.svg";